module.exports = __webpack_public_path__ + "static/img/home23.c3ad1e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home23.png
// module id = His9
// module chunks = 13